import type { CreatePartnerLeadRequest } from '@bliks-io/contracts';

/** Known contact details the lead wizard can start with, e.g. from the contact list. */
export type NewLeadPrefill = Partial<
  Pick<CreatePartnerLeadRequest, 'firstName' | 'lastName' | 'email' | 'phone' | 'company'>
>;

const EMPTY_LEAD: CreatePartnerLeadRequest = {
  salutation: undefined,
  title: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  company: '',
  role: '',
  interestProof: undefined,
  contactDate: '',
  positiveReaction: undefined,
  licenseType: undefined,
  typicalIndustries: '',
  openQuestions: '',
  comment: '',
  appointmentEventUri: '',
  appointmentInviteeUri: ''
};

export function leadDefaults(prefill?: NewLeadPrefill): CreatePartnerLeadRequest {
  return { ...EMPTY_LEAD, ...prefill };
}
